import { Component, Input, OnInit,SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { VacationAddComponent } from './vacation-add/vacation-add.component';
import {LabourService} from '../service/labour.service'
import { ConfirmDialogModel } from 'app/modules/common/components/confirmation-dialog/confirm-dialog-model';
import { ConfirmationDialogComponent } from 'app/modules/common/components/confirmation-dialog/confirmation-dialog.component';
import { SharedService } from 'app/modules/common/services/shared-service';
@Component({
    selector: 'app-vacation-list',
    templateUrl: './vacation-list.component.html',
    styleUrls: ['./vacation-list.component.scss'],
    standalone: false
})
export class VacationListComponent implements OnInit {

  @Input() getTreeViewData :any;
  selectedYear: number;
  years: number[] = [];
  leavesDataSource:any;
  selectedFetcha:any;

  constructor(
    private dialog: MatDialog,
    public labourService:LabourService,
    private sharedService: SharedService
  ){ }

  displayedColumns = ['name', 'symbol'];


  ngOnInit(): void {
    this.loadYears();
    this.loadFetchList(this.getTreeViewData)
  }

  ngOnChanges(changes: SimpleChanges){
    this.loadYears();
    this.loadFetchList(this.getTreeViewData)
  }

  loadYears()
  {
    this.selectedYear = new Date().getFullYear();

    for (let i=0 ; i <=20;i++) {
    this.years.push((this.selectedYear-5)+i);
    }
  }

  loadFetchList(dataSet:any)
  {
      this.labourService.getFetchaList(dataSet.level,this.selectedYear.toString(),dataSet.comunidad,dataSet.poblacion).subscribe(res=>{
        this.leavesDataSource=res.result;
      });
  }
  dateChange(date:any)
  {
    this.labourService.getFetchaList(this.getTreeViewData.level,date.toString(),this.getTreeViewData.comunidad,this.getTreeViewData.poblacion).subscribe(res=>{
      this.leavesDataSource=res.result;
    })
  }
  deleteFecha(selectedData:any)
  {
    this.selectedFetcha=selectedData;
    const dialogDatacopiar = new ConfirmDialogModel('¿Eliminar el día festivo del calendario?', '');
    const dialogRefcopiar = this.dialog.open(ConfirmationDialogComponent, {
      data: dialogDatacopiar
    });
    dialogRefcopiar.afterClosed().subscribe(res => {
      if(res){
        this.labourService.deleteFetcha(this.selectedFetcha).subscribe(resp=>{
          if(resp.result==0)
          {
            this.loadFetchList(this.getTreeViewData)
          }
        }, err => {
          console.error(err);
        })
      }
    });
  }

  public addvacation(data: any): void {
    const modalRef = this.dialog.open(VacationAddComponent, { data: this.getTreeViewData });
    modalRef.afterClosed().subscribe(res => {
      this.loadFetchList(this.getTreeViewData)
    });
  }


}

